import React, { forwardRef, type ReactElement } from 'react';

import classnames from 'classnames';

import { type SizeType } from '../../features/config';
import { Avatar } from '../Avatar';

import { type AvatarInputProps, type AvatarInputRef } from './AvatarInput.types';
import { AvatarInputEditMode } from './components/AvatarInputEditMode';

import styles from './AvatarInput.module.scss';

const DEFAULT_SIZE: SizeType = 'large';

export const AvatarInput = forwardRef<AvatarInputRef, AvatarInputProps>(
    (
        {
            size: sizeProp = DEFAULT_SIZE,
            slotProps = {},
            readOnly,
            className,
            ...avatarInputEditModeProps
        }: AvatarInputProps,
        ref
    ): ReactElement => {
        const { avatar: avatarProps } = slotProps;

        return (
            <div className={classnames(styles.root, className)}>
                {readOnly ? (
                    <Avatar withInitials size={sizeProp} {...avatarProps} />
                ) : (
                    <AvatarInputEditMode
                        ref={ref}
                        size={sizeProp}
                        slotProps={slotProps}
                        {...avatarInputEditModeProps}
                    />
                )}
            </div>
        );
    }
);

AvatarInput.displayName = 'AvatarInput';
